<div class="screenshot-toolbar">
  <div class="toolbar-section toolbar-begin">
    <cs-icon-button icon="close" (click)="onCloseClicked()"></cs-icon-button>
  </div>
  <div class="toolbar-section toolbar-middle">
    <cs-icon-button icon="pencil-sketch" [class.active]="editEnabled" (click)="toggleEditEnabled()"></cs-icon-button>
    <cs-icon-button icon="trash" (click)="onResetClicked()"></cs-icon-button>
  </div>
  <div class="toolbar-section toolbar-end">
    <cs-icon-button icon="circle" class="color-green" [fill]="lineColor === PenColor.Green" (click)="setLineColor(PenColor.Green)"></cs-icon-button>
    <cs-icon-button icon="circle" class="color-yellow" [fill]="lineColor === PenColor.Yellow" (click)="setLineColor(PenColor.Yellow)"></cs-icon-button>
    <cs-icon-button icon="circle" class="color-red" [fill]="lineColor === PenColor.Red" (click)="setLineColor(PenColor.Red)"></cs-icon-button>
  </div>
</div>
<div class="canvas-holder">
  <canvas #canvas></canvas>
</div>
<div class="form-placeholder" #formPlaceholder></div>
<div class="screenshot-form" #formFooter>
  <ng-content></ng-content>
</div>
